const thunker = ({ types, promise, data = {}}) => (
  async (dispatch) => {
    dispatch({ type: types[0], data });

    let response;
    try {
      response = await promise;
    } catch (err) {
      return dispatch({
        type: types[2],
        error: err,
      });
    }

    return dispatch({
      type: types[1],
      res: response,
      data,
    });
  }
);

export default thunker;



// WEBPACK FOOTER //
// ./src/actions/thunker.js